import React from 'react';
import { gql } from '@apollo/client';
import { FunctionField, NumberField, Show, SimpleShowLayout, TextField } from 'react-admin';
import DateTimeField from 'components/DateTimeField';
import LinkField from 'components/LinkField';

const ReverseInvoiceFileShow = () => (
  <Show>
    <SimpleShowLayout>
      <NumberField source="id" />
      <LinkField label="Company ID" source="company_id" typename="Company" />
      <TextField label="Status" source="status" />
      <TextField label="Original File Name" source="original_file_name" />
      <FunctionField
        label="Attachment"
        render={(record) =>
          record?.attachment ? (
            <a href={record.attachment} target="_blank" rel="noreferrer">
              Download
            </a>
          ) : (
            '-'
          )
        }
      />
      <LinkField
        label="Manually Imported By"
        source="manually_imported_by_account_id"
        typename="Account"
      />
      <NumberField label="Total Rows" source="total_rows" />
      <TextField label="Parser" source="parser" />
      <TextField label="Notes" source="notes" />
      <TextField label="Error Rows" source="error_rows" emptyText="-" />
      <DateTimeField label="Created At" source="created_at" format="MM/dd/yyyy HH:mm" />
      <DateTimeField label="Updated At" source="updated_at" format="MM/dd/yyyy HH:mm" />
    </SimpleShowLayout>
  </Show>
);

ReverseInvoiceFileShow.query = gql`
  query reverseInvoiceFile($id: Int!) {
    reverseInvoiceFile(id: $id) {
      id
      attachment
      company_id
      created_at
      error_shifts
      manually_imported_by_account_id
      notes
      original_file_name
      parser
      status
      total_rows
      updated_at
    }
  }
`;

export default ReverseInvoiceFileShow;
